export const DATA_TEST_ID = `modal`
export const DATA_TEST_ID_CLOSE_BUTTON = `${DATA_TEST_ID}-close-button`
